<template>
  <div id="Dashboard">
    <div>
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
        <van-row class="pl-4 pt-4 pr-4">
          <van-col span="24">
            <div class="demo-content">
              <h5>{{ getWork().work.WorkName }}</h5>
            </div>
            <p class="text-desc">考试机构上报工作情况汇总</p>
          </van-col>
        </van-row>
        <!-- 时间场次组件 -->
        <time-field @callback="drawStatusList"></time-field>
        <!-- 通知内容 -->
        <van-notice-bar
          color="#1989fa"
          background="#ecf9ff"
          left-icon="info-o"
          mode="closeable"
          v-if="dashboardData.ScrollMsg"
        >{{dashboardData.ScrollMsg}}</van-notice-bar>
        <!-- 考区工作环节宫格 -->
        <p class="text-desc color-blue">市机构工作环节</p>
        <van-grid :column-num="3">
          <van-grid-item
            v-for="(item,index) in dashboardData.AreaStatus"
            :key="index"
            icon="weapp-nav"
            :info="(item.AreaStatusFinished) ? parseInt(item.AreaStatusFinished / item.AreaStatusCount * 100) + '%' : '0'"
            :text="item.StatusName"
            @click="areaStatusScanBtn(item.StatusID)"
          />
        </van-grid>
        <!-- 考点工作环节宫格 -->
        <p class="text-desc color-blue">校机构工作环节</p>
        <van-grid :column-num="3">
          <van-grid-item
            v-for="(item,index) in dashboardData.AddrStatus"
            :key="index"
            icon="weapp-nav"
            :info="(item.AreaStatusFinished) ? parseInt(item.AreaStatusFinished / item.AreaStatusCount * 100) + '%' : '0'"
            :text="item.StatusName"
            @click="addrStatusScanBtn(item.StatusID)"
          />
        </van-grid>
      </van-pull-refresh>
    </div>

    <!--点击市机构工作环节列表弹出窗口-->
    <van-popup v-model="sheet1" :style="{width:'80%',height:'80%'}">
      <div class="m-4">
        <h3>{{ loadingData.StatusName }}</h3>
        <van-cell-group>
          <van-cell
            :title="item.AreaName"
            value="内容"
            :label="(item.OperationTime) ? '在' + item.OperationTime + '上报'+ getWorkStateText(item.Status) : '还没有上报状态'"
            v-for="(item,index) in loadingData.arealist"
            :key="index"
          />
        </van-cell-group>
      </div>
    </van-popup>

    <!--点击市机构"考区工作人员"工作环节列表弹出窗口-->
    <div id="sheet2" v-if="false">
      <div class="mui-card">
        <div class="mui-card-header">
          <div class="cust-title">{{ loadingData.StatusName }}</div>
          <div class="mui-icon mui-icon-close cust-full-right mr-2" @click="sheet2Prve()"></div>
        </div>
        <div class="mui-card-content mui-scroll-wrapper">
          <div class="mui-scroll">
            <ul class="mui-table-view">
              <li
                class="mui-table-view-cell mui-collapse"
                v-for="(e,i) in loadingData.arealist"
                :key="i"
              >
                <a class="mui-navigate-right" href="#">
                  {{ e.AreaName }}
                  <p>上报工作人员{{ e.WorkUserNum }} 人</p>
                </a>
                <div class="mui-collapse-content">
                  <div class v-for="(e_0,i_0) in e.WorkUserList" :key="i_0">
                    <div class="mui-card">
                      <!--页眉，放置标题-->
                      <div class="mui-card-header">
                        <i class="fa fa-fw fa-user"></i>
                        <div
                          class="mui-media-body"
                          style="justify-content:center"
                        >{{ e_0.RoleName }}</div>
                      </div>
                      <!--内容区-->
                      <div div v-if="e_0.ReportNum == '0'" class="mui-card-content">
                        <p>{{ e_0.RealName }}</p>
                        <p>{{ e_0.DutyName }}</p>
                        <p>{{ e_0.Phone }}</p>
                        <p>{{ e_0.Tel }}</p>
                      </div>
                      <div v-else class="mui-card-content">
                        <p>{{ e_0.UserCount }}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <!--点击校机构工作环节列表,查看校机构考试工作任务上报情况-->
    <div id="sheet3" v-if="false">
      <div class="mui-card">
        <div class="mui-card-header">
          <div class="cust-title">{{ loadingData.StatusName }}</div>
          <div class="mui-icon mui-icon-close cust-full-right mr-2" @click="sheet3Prve()"></div>
        </div>
        <div class="mui-card-content mui-scroll-wrapper">
          <div class="mui-scroll">
            <ul class="mui-table-view">
              <li
                v-for="(e,i) in loadingData.arealist"
                :key="i"
                class="mui-table-view-cell mui-collapse"
              >
                <a
                  class="mui-navigate-right"
                  href="#"
                >{{ e.AreaName }} ({{ e.StatusFinished + "/" + e.StatusCount }})</a>
                <div class="mui-collapse-content">
                  <ul v-for="(e_0,i_0) in e.loadingData" :key="i_0">
                    <li class="text-left m-2">
                      <i :class="getWorkStateIcon(e_0.Status)"></i>
                      <b>{{ e_0.AddrName }}</b>
                      <p>
                        上报状态:{{ getWorkStateText(e_0.Status) }}
                        <small>{{ e_0.OperationTime }}</small>
                      </p>
                    </li>
                  </ul>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <!--点击校机构"考点工作人员"考试工作任务查看上报情况-->
    <div id="sheet4" v-if="false">
      <div class="mui-card">
        <div class="mui-card-header">
          <div class="cust-title">{{ loadingData.StatusName }}</div>
          <div class="mui-icon mui-icon-close cust-full-right mr-2" @click="sheet4Prve()"></div>
        </div>
        <div class="mui-card-content mui-scroll-wrapper">
          <div class="mui-scroll">
            <ul class="mui-table-view">
              <li
                v-for="(e,i) in loadingData.arealist"
                :key="i"
                class="mui-table-view-cell mui-collapse"
              >
                <a
                  class="mui-navigate-right"
                  href="#"
                >{{ e.AreaName }} ({{ e.StatusFinished + "/" + e.StatusCount }})</a>
                <div class="mui-collapse-content">
                  <ul v-for="(e_0,i_0) in e.loadingData" :key="i_0">
                    <li class="text-left m-2">
                      <i :class="getWorkStateIcon(e_0.Status)"></i>
                      <b>{{ e_0.AddrName }}</b>
                      <p>工作人员:{{ e_0.WorkUserNum }}</p>
                      <ul>
                        <li v-for="(e_1,i_1) in e_0.WorkUserList" :key="i_1">
                          {{ e_1.RoleName }} {{ e_1.RealName }} {{ e_1.DutyName }}
                          {{ e_1.Phone }} {{ e_1.Tel }}
                        </li>
                      </ul>
                    </li>
                  </ul>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <!--点击校机构"监考名单上报"考试工作任务查看上报情况-->
    <div id="sheet5" v-if="false">
      <div class="mui-card">
        <div class="mui-card-header">
          <div class="cust-title">{{ loadingData.StatusName }}</div>
          <div class="mui-icon mui-icon-close cust-full-right mr-2" @click="sheet5Prve()"></div>
        </div>
        <div class="mui-card-content mui-scroll-wrapper">
          <div class="mui-scroll">
            <ul class="mui-table-view">
              <li
                v-for="(e,i) in loadingData.arealist"
                :key="i"
                class="mui-table-view-cell mui-collapse"
              >
                <a
                  class="mui-navigate-right"
                  href="#"
                >{{ e.AreaName }} ({{ e.StatusFinished + "/" + e.StatusCount }})</a>
                <div class="mui-collapse-content">
                  <ul v-for="(e_0,i_0) in e.loadingData" :key="i_0">
                    <li class="text-left m-2">
                      <i :class="getWorkStateIcon(e_0.Status)"></i>
                      <b>{{ e_0.AddrName }}</b>
                      <p>
                        上报状态:{{ getWorkStateText(e_0.Status) }}
                        <small>{{ e_0.OperationTime }}</small>
                      </p>
                    </li>
                  </ul>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <!--点击校机构"缺考信息上报"考试工作任务查看上报情况-->
    <div id="sheet6" v-if="false">
      <div class="mui-card">
        <div class="mui-card-header">
          <div class="cust-title">{{ loadingData.StatusName }}</div>
          <div class="mui-icon mui-icon-close cust-full-right mr-2" @click="sheet6Prve()"></div>
        </div>
        <div class="mui-card-content mui-scroll-wrapper">
          <div class="mui-scroll">
            <ul class="mui-table-view">
              <li
                v-for="(e,i) in loadingData.arealist"
                :key="i"
                class="mui-table-view-cell mui-collapse"
              >
                <a
                  class="mui-navigate-right"
                  href="#"
                >{{ e.AreaName }} ({{ e.StatusFinished + "/" + e.StatusCount }})</a>
                <div class="mui-collapse-content">
                  <ul v-for="(e_0,i_0) in e.loadingData" :key="i_0">
                    <li class="text-left m-2">
                      <i :class="getWorkStateIcon(e_0.Status)"></i>
                      <b>{{ e_0.AddrName }}</b>
                      <p>
                        上报状态:{{ getWorkStateText(e_0.Status) }}
                        <small>{{ e_0.OperationTime }}</small>
                      </p>
                    </li>
                  </ul>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import timeField from "@/components/TimeField.vue";
export default {
  name: "Dashboard",
  data() {
    return {
      sheet1: false,
      sheet2: false,
      isLoading: false,
      dashboardData: {},
      loadingData: []
    };
  },
  components: {
    timeField
  },
  watch: {},
  methods: {
    onRefresh() {
      setTimeout(() => {
        this.isLoading = false;
        this.drawStatusList();
        this.$toast.loading({
          message: "加载中...",
          forbidClick: true
        });
      }, 500);
    },
    //选择考试场次
    selectExamBtn: function(event) {
      var timeStr = event.target.innerText;
      this.setExamTime(timeStr);
      this.ExamTimeList = this.getWork().work.ExamTimeList;
      this.drawStatusList();
    },
    drawStatusList() {
      this.apiStatusScanGet(
        {
          WorkID: this.getWork().work.WorkID,
          BeginTime: this.getExamTime().beginTime
        },
        this,
        e => {
          //eslint-disable-next-line
          console.log(e);
          this.dashboardData = e;
        }
      );
    },
    /* 考区工作环节查看 */
    areaStatusScan(statusID) {
      this.apiStatusScanGet(
        {
          WorkID: this.getWork().work.WorkID,
          BeginTime: this.getExamTime().beginTime,
          StatusID: statusID
        },
        this,
        e => {
          this.loadingData = e;
          switch (e.StatusID) {
            case "AreaStaff":
              this.sheet2 = true;
              break;
            default:
              this.sheet1 = true;
              break;
          }
        }
      );
    },
    addrStatusScanBtn(statusID) {
      this.apiStatusScanGet(
        {
          WorkID: this.getWork().work.WorkID,
          BeginTime: this.getExamTime().beginTime,
          StatusID: statusID
        },
        this,
        e => {
          this.loadingData = e;
          switch (e.StatusID) {
            case "AddrStaff":
              this.$mui("#sheet4").popover("show");
              break;
            case "Monitor":
              this.$mui("#sheet5").popover("show");
              break;
            case "MissExam":
              this.$mui("#sheet6").popover("show");
              break;
            default:
              this.$mui("#sheet3").popover("show");
              break;
          }
        }
      );
    }
  },
  created() {
    if (this.getExamTime().beginTime) {
      this.ExamTimeList = this.getWork().work.ExamTimeList;
      this.drawStatusList(); //渲染考试工作任务列表
    } else {
      this.$toast("未选择考试场次,无法查看工作情况");
    }
  }
};
</script>

<style scoped>
</style>